import React, { useState, useEffect, Fragment } from "react";
import { connect } from "react-redux";
import { _HttpServices } from "./../../../_services/_HttpServices";
import ReactTable from "./../../../components/FilterTable";
import { Button } from "react-bootstrap";
import { IoMdCreate, IoIosAdd, IoMdDownload,IoMdTrash,IoMdDoneAll,IoIosClose } from "react-icons/io";
import { useHistory } from "react-router-dom";
import { Toast,Modal } from "react-bootstrap";
// Local imports
import Loader from "./../../../components/Loader";
import moment from 'moment'
import getExcel from "./../../../_services/ExcelUtility";
import { Footer } from "../../../components/Footer";

const Holidays = ({ dispatch, login }) => {
  const fileName = 'Holidays';
  const history = useHistory();
  const [holidays, setHolidays] = useState([]);
  const [showToaster, setShowToaster] = useState(false);
  const [userUpdated, setUserUpdated] = useState(false);
  const [holidayDelete, setHolidayDelete] = useState(false);
  const [loading, setLoading] = useState(false);
  const [loggedInUserData, setLoggedInUserData] = useState({});
  const [hasError, setHasError] = useState(false);
  const [showCancelToaster, setCancelShowToaster] = useState(false);
  const [holidayID, setHolidayID] = useState();
 
  useEffect(() => {
    getHolidays();
    if (localStorage.getItem("userData")) {
      setLoggedInUserData(JSON.parse(localStorage.getItem("userData")));
    }
  }, []);
  const getHolidays = async () => {
      setLoading(true)
      await _HttpServices
      .getData(`Api/Client/GetListOfHolidays`)
      .then((response) => {
        if (response.data) {
          let holidaysList = response.data.filter((re) => re.Isactive === true);
          holidaysList.map(res => {
            res.HolidayDate = moment(res.HolidayDate).format('MM/DD/YYYY');
          })
          setHolidays(holidaysList)
          setLoading(false)
        }
      })
      .catch((e) => {
        console.log(e);
        setHasError(true)
        setLoading(false);
      });
  };
  let columns = []
  if (loggedInUserData.RoleID === 1) {
  columns = [
      {
        Header: "Holiday Description",
        accessor: "HolidayDescription",
        filter: "HolidayDescription",
        sortType: "basic",
        width:200
      },
      {
        Header: "Holiday Date",
        accessor: "HolidayDate",
        filter: "HolidayDate",
        sortType: "basic",
      },
      {
        Header: "Actions",
        accessor: "accessor",
        disableFilters: true,
        disableSortBy: true,
        width: 80,
        Cell: ({ row: { original } }) => (
          <Fragment>
            {loggedInUserData.RoleID !== 2 && (
              <Button
                variant="link"
                title="Delete Holiday"
                onClick={() =>deleteHoliday(original.HolidayID)}
                className="grid-action-btn"
              >
                <IoMdTrash className="icon" />
              </Button>
            )}
          </Fragment>
        ),
      },
    ];
  }
  if (loggedInUserData.RoleID === 2) {
    columns = [
      {
        Header: "Holiday Description",
        accessor: "HolidayDescription",
        filter: "HolidayDescription",
        sortType: "basic",
        width:200
      },
      {
        Header: "Holiday Date",
        accessor: "HolidayDate",
        filter: "HolidayDate",
        sortType: "basic",
      },
      
        
    ];
  }
    const deleteHoliday = (id) => {
      console.log("deleteHoliday");
      setHolidayID(id);
      setCancelShowToaster(true);
    }
  const deleteHolidayHandler = () => {
    setLoading(true);
    _HttpServices.postData(`api/Client/DeleteHoliday?HolidayID=`+holidayID)
    .then((response)=>{
      if(response.data){
        setLoading(false);
        setShowToaster(true);
        setHolidayDelete(true);
        setCancelShowToaster(false)
        getHolidays();
      }
    })
    .catch((error) => {
      setLoading(false);
    })
  };

 const AddHoliday = () => {
    history.push("/addHoliday");
 }
  return (
    <section className="content">
      <div className="page-title">
        <h2 className="h2">Holidays</h2>
        <div>
        {loggedInUserData.RoleID !== 2 && (
            <Button onClick={()=>AddHoliday()}>
              <IoIosAdd className="icon btn-icon" />
                Add Holiday
            </Button>
        )}
          <Button className="ml-2" onClick={() => getExcel(columns, holidays, fileName)}><IoMdDownload className="icon btn-icon" />Download Excel</Button>
        </div>
      </div>
      {/* Toaster */}
      <Toast
        onClose={() => setShowToaster(false)}
        show={showToaster}
        delay={1500}
        autohide
        className="custom-toaster"
      >
        {holidayDelete && <Toast.Body>Holiday deleted Successfully</Toast.Body>}
      </Toast>
      <Modal show={showCancelToaster}
          onHide={() => setCancelShowToaster(false)}
          backdrop="static"
          keyboard={false} >
          <Modal.Header closeButton>
              <Modal.Title>
                  <img src="holder.js/20x20?text=%20" className="rounded mr-2" alt="" />
                  <strong>Confirm</strong>
              </Modal.Title>
          </Modal.Header>
          <Modal.Body>
              <p className="ml-2">Are you sure want to Delete Holiday?</p>
          </Modal.Body>
          <Modal.Footer>
              {/* onClick={forgotPasswordHandle} */}
              <div className="text-right mt-2">
                  <Button
                      onClick={() => deleteHolidayHandler()}
                  >
                      <IoMdDoneAll className="icon btn-icon" />Yes</Button>
                  <Button
                      variant="danger"
                      className="ml-3 btn-sm"
                      onClick={() => setCancelShowToaster(false)}
                  >
                      <IoIosClose className="icon btn-icon" />No</Button>
              </div>
          </Modal.Footer>

      </Modal>
      {/* <Toast
        onClose={() => setCancelShowToaster(false)}
        show={showCancelToaster}
        style={{
          position: "absolute",
          top: "100px",
          right: 0,
          bottom: 0,
          left: 0,
          margin: "0 auto",
          height: "140px",
          width: "500px",
          zIndex: "99",
        }}
      >
        <Toast.Body>
          <h3 className="h6">Are you sure want to Delete Holiday</h3>
          <div className="text-right mt-4">
            <Button onClick={() => deleteHolidayHandler()}
            >
              <IoMdDoneAll className="icon btn-icon" />
              Yes
            </Button>
            <Button
              variant="danger"
              className="ml-3 btn-sm"
              onClick={() => setCancelShowToaster(false)}
            >
              <IoIosClose className="icon btn-icon" />
              No
            </Button>
          </div>
        </Toast.Body>
      </Toast> */}
      <div className="users-grid-wrap">
        <div className="card pt-3">
          <div className="card-body">
            {
              holidays.length !== 0 ? <ReactTable columns={columns} data={holidays} defaultPageSize={10} /> : 
              hasError ? <p>Error occurred. Unable to load Holidays.</p> :
              <div className="no-data">No data found.</div>
            }
          </div>
        </div>
      </div>
      {loading ? <Loader /> : null}

      <Footer />
    </section>
  );
};

// Map Redux state to React component props
const mapStateToProps = (state) => ({
  loading: state.users.loading,
  login: state.users.login,
  users: state.users.users,
  hasErrors: state.users.hasErrors,
});

// Connect Redux to React
export default connect(mapStateToProps)(Holidays);
